import { render } from "./WCProductCardGroup.vue?vue&type=template&id=4ab77ad8&scoped=true"
import script from "./WCProductCardGroup.vue?vue&type=script&lang=js"
export * from "./WCProductCardGroup.vue?vue&type=script&lang=js"

import "./WCProductCardGroup.vue?vue&type=style&index=0&id=4ab77ad8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab77ad8"]])

export default __exports__